import { Case } from '../../../beans/Case';
import { Nomenclature } from '../../../beans/Nomenclature';
import { Lawyer } from '../../../beans/Lawyer';
import { Person } from '../../../beans/Person';
import { FrxBaseBean } from '../../../beans/frxbasebean';
import { WordTemplate } from '../../../beans/word-template';
import { BlockUiService } from '../../../services/blockui.service';
import { CaseService } from '../../../services/case.service';
import { NomenclatureService } from '../../../services/nomenclature.service';
import { PersonService } from '../../../services/person.service';
import { WordTemplateService } from '../../../services/word-template.service';
import { EditCaseComponent } from '../edit-case.component';
import { DatePipe } from '@angular/common';
import { Component, OnInit, Input, ViewChild, ViewContainerRef, Host, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'app-edit-case-main',
	templateUrl: './edit-case-main.component.html',
	styleUrls: ['./edit-case-main.component.scss']
})
export class EditCaseMainComponent implements OnInit {

	@ViewChild('editPerson') editPerson;

	errorMessage = '';
	_editedCase: Case;

	claimant: Person;
	defendant: Person;
	helper: Person;
	dead: Person;

	editedPerson = new Person();

	// Loaded object lsits bellow
	lawyers: Array<Lawyer>;
	damageTypes: Array<Nomenclature>;
	traumaType: Array<Nomenclature>;

	// Word templates
	deloTemplates: WordTemplate[] = [];
	selectedDeloTemplate: WordTemplate = null;

	constructor(
		private caseService: CaseService,
		private nomenclatureService: NomenclatureService,
		private blockUi: BlockUiService,
		private vcRef: ViewContainerRef,
		private personService: PersonService,
		private datePipe: DatePipe,
		private wordTemplateService: WordTemplateService
	) {
	}

	ngOnInit() {
		this.loadLawyers();
		this.loadDamageTypes();
		this.loadTraumaTypes();
		this.loadDeloTemplates();
	}

	private loadDeloTemplates() {
		this.wordTemplateService.findByType('DELO').subscribe(
			data => this.deloTemplates = data.filter(t =>
				!t.placeholderCategories ||
				(!t.placeholderCategories.includes('GRAZHDANSKA_INSTANCIJA') &&
				 !t.placeholderCategories.includes('NAKAZATELNO') &&
				 !t.placeholderCategories.includes('IZPULNITELNO'))
			),
			err => { }
		);
	}

	generateDocument() {
		if (!this.selectedDeloTemplate || !this._editedCase || !this._editedCase.id) return;
		this.blockUi.start(this.vcRef);
		this.wordTemplateService.generateDocument(this.selectedDeloTemplate.id, this._editedCase.id).subscribe(
			resp => {
				this.blockUi.stop();
				const blob = resp.body;
				const url = window.URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.href = url;
				a.download = this.selectedDeloTemplate.name + '_generated.docx';
				a.click();
				window.URL.revokeObjectURL(url);
			},
			err => {
				this.blockUi.stop();
				alert('Грешка при генериране на документ');
			}
		);
	}


	private loadDamageTypes() {
		this.damageTypes = new Array<Nomenclature>();
		this.nomenclatureService.getDamageTypes().subscribe(types => {
			this.damageTypes = types;
		});
	}

	private loadTraumaTypes() {
		this.traumaType = new Array<Nomenclature>();
		this.nomenclatureService.getTraumaTypes().subscribe(types => {
			this.traumaType = types;
		});
	}

	private loadLawyers() {
		this.lawyers = new Array<Lawyer>();
		this.nomenclatureService.getLawyers().subscribe(
			lawyers => {
				this.lawyers = lawyers;
			});
	}

	@Input()
	public set editedCase(val: Case) {
		this.editCase(val);
	}

	public get editedCase() {
		return this._editedCase;
	}

	public editCase(caseObj: Case): void {
		this.refreshCase();
		this.errorMessage = '';
		if (caseObj && caseObj.id) {
			this._editedCase.copy(caseObj);
		}
	}

	public reset(caseObj): void {
		this._editedCase = new Case();
		if (caseObj) {
			this._editedCase = caseObj;
		}
	}

	prepareCaseDto(caseObj: Case) : any{
		return {
			...caseObj,

			// ДАТИ → backend must receive YYYY-MM-DD
			date: this.caseService.toBackendIsoDate(caseObj.date),
			claimDate: this.caseService.toBackendIsoDate(caseObj.claimDate),

		};
	}

	saveCase() {
		this.blockUi.start(this.vcRef);

		try {
			let dto = this.prepareCaseDto(this.editedCase);

			// TEST
			console.log("DTO for backend:", dto);

			this.caseService.saveCase(dto, this.editedCase.id != null).subscribe(
				result => {
					this.blockUi.stop();
					alert('Делото беше записано успешно');
				},
				error =>  {
					this.blockUi.stop();
					this.errorMessage = 'Грешка при запис: ';
					if (error && error.error && error.error.message) {
						this.errorMessage += error.error.message;
					}
				}
			);

		} catch (error) {
			this.errorMessage = 'Грешен формат на дата';
			this.blockUi.stop();
		}
	}


	refreshCase() {
		this.errorMessage = '';
		this._editedCase = new Case();
		this.claimant = new Person();
		this.defendant = new Person();
		this.dead = new Person();
		this.helper = new Person();
		this._editedCase.claimentList = new Array<Person>();
		this._editedCase.defendantList = new Array<Person>();
		this._editedCase.helpersList = new Array<Person>();

	}


	observableSource(keyword: string): any {
		return this.personService.searchPersons(keyword);
	}

	addClaiment() {
		this.addPersonToList(this.claimant, 'claimentList');
	}


	addDefendant() {
		this.addPersonToList(this.defendant, 'defendantList');
	}

	addDead() {
		this.addPersonToList(this.dead, 'deadList');
	}

	addHelper() {
		this.addPersonToList(this.helper, 'helpersList');
	}

	addPersonToList(person: Person, listName: string) {
		if (person && person.id && this._editedCase[listName]) {
			this._editedCase[listName].push(person);
		}
	}

	compareFrxObjects(o1: FrxBaseBean, o2: FrxBaseBean) {
		if (o1 && o2) {
			return o1.id === o2.id;
		}
	}


	reloadPersons(person: Person, callbackListName: string) {
		switch (callbackListName) {
			case 'claimentList': this.removeClaiment(this.editedPerson); break;
			case 'defendantList': this.removeDefendant(this.editedPerson); break;
			case 'deadList': this.removeDead(this.editedPerson); break;
			case 'helpersList': this.removeHelper(this.editedPerson); break;
		}
		this.addPersonToList(person, callbackListName);
	}

	removeClaiment(person) {
		this.removePersonFromList(person, this._editedCase.claimentList);
	}
	removeDefendant(person) {
		this.removePersonFromList(person, this._editedCase.defendantList);
	}

	removeDead(person) {
		this.removePersonFromList(person, this._editedCase.deadList);
	}
	removeHelper(person) {
		this.removePersonFromList(person, this._editedCase.helpersList);
	}
	editClaiment(person) {
		this.editedPerson.copy(person);
		this.editPerson.editPersonForCase(person, this.getCurrentComponent(), 'claimentList');
	}
	editDefendant(person) {
		this.editedPerson.copy(person);
		this.editPerson.editPersonForCase(person, this.getCurrentComponent(), 'defendantList');
	}
	editDead(person) {
		this.editedPerson.copy(person);
		this.editPerson.editPersonForCase(person, this.getCurrentComponent(), 'deadList');
	}
	editHelper(person) {
		this.editedPerson.copy(person);
		this.editPerson.editPersonForCase(person, this.getCurrentComponent(), 'helpersList');
	}
	removePersonFromList(person: Person, list: Array<Person>) {
		const index = list.findIndex(i => i.id === person.id);
		if (index > -1) {
			list = list.splice(index, 1);
		}
	}

	getCurrentComponent() {
		return this;
	}
}
